<template>
    <v-layout wrap class="search">
        <v-flex xs12>
            <v-tabs fixed-tabs v-model="tab" color="black accent-4">
                <v-tabs-slider color="black"></v-tabs-slider>
                <v-tab
                    :key="1"
                    :href="'#tab-1'"
                >
                    <v-icon>mdi-magnify</v-icon>
                    Salesforce
                </v-tab>
                <v-tab
                    :key="2"
                    :href="'#tab-2'"
                >
                    <v-icon>mdi-magnify</v-icon>
                    CeleraOne/SAP
                </v-tab>
                <v-tab-item :key="1" :value="'tab-1'">
                    <v-layout wrap>
                        <v-flex>
                            <SalesforceSearch />
                        </v-flex>
                    </v-layout>
                </v-tab-item>
                <v-tab-item :key="2" :value="'tab-2'">
                    <v-layout wrap>
                        <v-flex xs3>
                            <SimpleSearch class="mr-2" />
                        </v-flex>
                        <v-flex xs9>
                            <SimpleCustomerResult class="ml-2" />
                        </v-flex>
                    </v-layout>
                </v-tab-item>
            </v-tabs>
        </v-flex>
    </v-layout>
</template>
<script>
import SimpleSearch from '@/components/search/SimpleSearch.vue';
import SalesforceSearch from '@/components/search/SalesforceSearch.vue';
import SimpleCustomerResult from '@/components/customer/SimpleCustomerResult.vue';

export default {
    name: 'Search',
    components: {
        SimpleSearch,
        SimpleCustomerResult,
        SalesforceSearch,
    },
    data() {
        return {
            tab: null,
        };
    },
};

</script>
<style scoped lang="scss"></style>
